// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'It looks like you got lost!',
  text: 'The address or resource you are looking for does not exist. It may have even existed, but it has been moved or disabled.',
  btn: {
    text: 'How about going back home?',
    title: 'click here to return to the home page',
  },
} as ILanguage;
